export enum ProspectStatusEnum {
  Active = 1,
  Closed = 2,
}

export const ProspectStatusStringEnum = {
  Active: 'Active',
  Closed: 'Closed',
};
